import config from '../service/config';
import Constants, {LinkIDs} from '../constants/Constants';

const getLinkBasedOnPlatform = (linkId: LinkIDs): string => config.featureSwitches.IsScreencast ? (Constants.navigation.screencast as Record<string, string>)[linkId] : (Constants.navigation.knowmia as Record<string, string>)[linkId];

export {getLinkBasedOnPlatform};
